<script setup>
import {RouterView} from "vue-router"
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { isMobileDevice } from '@/utils/common.js';
// 全局样式
import { customerTheme } from '@/customerTheme.js';

dayjs.locale('zh-cn');
const locale = ref(zhCN)

const getPopupContainer = (node) => {
  if (node) {
    return node.parentNode;
  } else {
    return document.body;
  }
}

// 根据设备分辨率判断当前是否已移动端状态进行显示
// const mediaQuery = isMobileDevice();
// onMounted(()=>{
//   console.log('mediaQuery',mediaQuery);
// })


</script>

<template>
  <a-config-provider :locale="locale" :getPopupContainer="getPopupContainer" :theme="customerTheme">
    <router-view/>
  </a-config-provider>
</template>
